module.exports = __webpack_public_path__ + "img/stick-figure.d176bd66.png";